import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import PaperDraggable from "../../../../../../components/PaperDraggable";
import { Controller, useForm } from "react-hook-form";
import { useMutation, useQueryClient } from "react-query";
import axiosClient from "../../../../../../lib/axios";
import { enqueueSnackbar } from "notistack";
import BtnLoading from "../../../../../../components/BasicComponents/Buttons/BtnLoading";

export default function DialogCancelarExpedicao({
    open,
    expedicao_id,
    handleClose
}: DialogCancelarExpedicaoProps) {

    const queryClient = useQueryClient();

    //Querys e mutations
    const { mutate: cancelarExpedicao, isLoading } = useMutation({
        mutationKey: 'cancelar-expedicao-pedido',
        mutationFn: (input: TCancelarMutation) => axiosClient.post(`/comercial/pedidos/cancelar-expedicao/${input.expedicao_id}`, input),
        onError: (error) => {
            console.error(error)
            enqueueSnackbar('Erro ao cancelar expedição!', { variant: 'error' });
        },
        onSuccess: () => {
            enqueueSnackbar(`Expedição cancelada com sucesso!`, { variant: 'success' });
            queryClient.invalidateQueries(`comercial/detalhar-pedido`);
            handleClose();
        }
    })

    const methods = useForm<TCancelarExpedicao>({
        defaultValues: {
            motivo_cancelamento: ''
        }
    })
    const { handleSubmit, control } = methods;



    const onSubmit = (data: TCancelarExpedicao) => {
        const params: TCancelarMutation = {
            expedicao_id,
            motivo_cancelamento: data.motivo_cancelamento
        }
        cancelarExpedicao(params)
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            maxWidth={"sm"}
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Cancelar expedição</DialogTitle>
            <DialogContent>

                <Grid container spacing={2} mt={0.1}>
                    <Grid size={{xs: 12}}>

                        <Controller
                            control={control}
                            name="motivo_cancelamento"
                            rules={{ required: "Campo obrigatório" }}
                            render={({ field, fieldState: { invalid, error } }) => (
                                <TextField
                                    {...field}
                                    label="Motivo do cancelamento"
                                    error={invalid}
                                    fullWidth
                                    multiline
                                    minRows={3}
                                    helperText={error?.message}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    color="primary"
                    disabled={isLoading}
                    onClick={handleClose}
                >
                    Fechar
                </Button>
                <BtnLoading
                    color="error"
                    variant="contained"
                    loading={isLoading}
                    loadingText={"Cancelando..."}
                    disabled={isLoading}
                    onClick={handleSubmit(onSubmit)}
                >
                    Cancelar
                </BtnLoading>
            </DialogActions>
        </Dialog>
    )
}

interface DialogCancelarExpedicaoProps {
    open: boolean;
    handleClose: () => void;
    expedicao_id: number
}

type TCancelarExpedicao = {
    motivo_cancelamento: string;
}

type TCancelarMutation = {
    motivo_cancelamento: string;
    expedicao_id: number;
}
